import psl, { ParsedDomain } from "psl";

const decodeCookie = (name: string) => {
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookie = decodedCookie.split(";");
  for (let i = 0; i < cookie.length; i++) {
    let cookie_str = cookie[i];
    while (cookie_str.charAt(0) === " ") {
      cookie_str = cookie_str.substring(1);
    }
    if (cookie_str.indexOf(name) === 0) {
      const value = cookie_str.substring(name.length + 1); 
      if (value) {
        return name === "accessToken=" ? `Bearer ${value}` : value;
      }
    }
  }

  return "";
};

export const accessToken = () => {
  const userToken =
    typeof window !== "undefined" ? decodeCookie("accessToken") : "";

  return userToken;
};

export const setAccessToken = (accessToken: string, expiresIn?: string) => {
  const expires = `;max-age=${expiresIn ?? 86400}`;
  let domain = "";
  if (window.location.hostname === "localhost") {
    domain = "localhost";
  } else {
    const parsed = psl.parse(window.location.hostname);
    domain = (parsed as ParsedDomain).domain ?? "";
  }
  document.cookie = `accessToken=${accessToken}${expires};path=/;${
    window.location.protocol === "https" ? "secure;" : ""
  }`;
};

export const logOut = () => {
  sessionStorage.clear();
  localStorage.clear();
  let domain = "";
  if (window.location.hostname === "localhost") {
    domain = "localhost";
  } else {
    const parsed = psl.parse(window.location.hostname);
    domain = (parsed as ParsedDomain).domain ?? "";
  }
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
    document.cookie = `${name}=;max-age=-99999999;path=/;${
      window.location.protocol === "https" ? "secure;" : ""
    }`;
  }
  document.cookie = `accessToken=;max-age=-99999999;path=/;domain=${domain}${
    window.location.protocol === "https" ? "secure;" : ""
  }`;
};

export const isAuth = () => {
  return Boolean(accessToken());
};

export const valueCookie = (name: string) => {
  const value = typeof window !== "undefined" ? decodeCookie(name) : "";
  return value;
};

export const setValueToCookie = (
  name: string,
  value: string,
  expiresIn?: string
) => {
  const expires = `;max-age=${expiresIn ?? 86400}`;
  document.cookie = `${name}=${value}${expires};path=/;${
    window.location.protocol === "https" ? "secure;" : ""
  }`;
};
